import React, { useState, ReactElement } from 'react';
import { __SESSION_MANAGEMENT_STORAGE__ } from 'shell/constants/environment';
import { User } from 'shell/models/user';
import useLocalStorage from '../use-local-storage';
import { initialContext, ProviderAuthentication } from './context';
import { SessionManagementEnum, UserProfile } from './types';

interface Properties {
  children: ReactElement;
}

const isStorageManagement = __SESSION_MANAGEMENT_STORAGE__ === SessionManagementEnum.Storage;
const storageKey = 'pmi-ls-usr';
const useProfileStore = isStorageManagement
  ? (ctx: UserProfile) => useLocalStorage(storageKey, ctx)
  : useState;

/**
 * Component Authentication loader
 * @param {*} props the root object
 * @returns {React.ReactComponentElement} the react component
 */
export const AuthenticationProvider = ({ children }: Properties): ReactElement => {
  const [userProfile, setUserProfile] = useProfileStore<UserProfile>(initialContext);

  /**
   * open login modal
   * @param {*} open the root object
   */
  const openLoginModal = React.useCallback(
    (open) => {
      setUserProfile({ ...userProfile, stateLoginModal: open, isLoading: false });
      return true;
    },
    [setUserProfile, userProfile]
  );

  /**
   * set datilogin
   * @param {object} datiLogin the root object
   */
  const setDatiLogin = React.useCallback(
    (datiLogin: User | undefined): UserProfile => {
      const returnObject = { ...userProfile, datiLogin, isLoading: false };
      setUserProfile(returnObject);
      return returnObject;
    },
    [setUserProfile, userProfile]
  );

  return (
    <ProviderAuthentication
      value={{
        userProfile: userProfile || {},
        setUserProfile: setDatiLogin,
        openLoginModal,
      }}
    >
      {children}
    </ProviderAuthentication>
  );
};

AuthenticationProvider.displayName = 'Authentication Provider componet';
